import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type DelayedReportAdvancedFilters = {
  minDelay: number | null;
};

@Component({
  selector: 'app-delayed-report-filters-modal',
  templateUrl: './delayed-report-filters.modal.html',
  styleUrls: ['./delayed-report-filters.modal.scss'],
})
export class DelayedReportFiltersModalComponent {
  filtersForm: FormGroup;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly dialogReference: MatDialogRef<DelayedReportFiltersModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: { initial: DelayedReportAdvancedFilters | null; defaultMin: number }
  ) {
    const initialMinimumDelayHours = dialogData?.initial?.minDelay ?? dialogData?.defaultMin ?? 72;
    this.filtersForm = this.formBuilder.group({
      minDelay: [
        initialMinimumDelayHours,
        [Validators.required, Validators.min(0), Validators.max(1000), Validators.pattern(/^\d+$/)],
      ],
    });
  }

  close(): void {
    this.dialogReference.close('close');
  }

  apply(): void {
    if (this.filtersForm.invalid) return;
    const value = this.filtersForm.getRawValue() as DelayedReportAdvancedFilters;
    if (value?.minDelay !== null && value?.minDelay !== undefined) {
      const clamped = Math.max(0, Math.min(1000, Number(value.minDelay)));
      value.minDelay = Number.isNaN(clamped) ? null : clamped;
    }
    this.dialogReference.close(value);
  }
}
